const ScrollHeader = function() {
    function ScrollHeader() {
        this.selector = {

        }
        this.load();
    }
    ScrollHeader.prototype.load = function() {
        var _ = this;
        // T5.55 — rAF-throttle + passive listener + flip-guard. The handler fired on
        // every scroll event and wrote to body.classList unconditionally; now it coalesces
        // to one rAF per frame, marks the listener passive (no scroll-blocking), and only
        // touches classList when the scrolled state actually changes. (INP / main-thread.)
        var ticking = false;
        var isScrolled = false;
        window.addEventListener('scroll', () => {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(() => {
                const scrolled = window.scrollY > 0;
                if (scrolled !== isScrolled) {
                    isScrolled = scrolled;
                    document.body.classList.toggle('scrolled-down', scrolled);
                }
                ticking = false;
            });
        }, { passive: true })
    }
    ScrollHeader = new ScrollHeader;
}
ScrollHeader();